import React, { useLayoutEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Paper,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import TuneIcon from "@mui/icons-material/Tune";

const GuestListTutorial = ({ step, anchorRef, onNext, onFinish }) => {
  const [rect, setRect] = useState(null);

  useLayoutEffect(() => {
    if (step !== "filter") return;

    const measure = () => {
      const el = anchorRef?.current;
      if (el) setRect(el.getBoundingClientRect());
    };

    measure();
    window.addEventListener("resize", measure);
    window.addEventListener("scroll", measure, true);
    return () => {
      window.removeEventListener("resize", measure);
      window.removeEventListener("scroll", measure, true);
    };
  }, [step, anchorRef]);

  if (step === "welcome") {
    return (
      <Dialog open fullWidth maxWidth="xs" onClose={onNext}>
        <DialogTitle sx={{ textAlign: "center" }}>
          Welcome to the Guest List
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            <Typography variant="body1">
              This is everyone checked in for tonight&apos;s event. Each card is
              a guest you could meet.
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  flexShrink: 0,
                  px: 0.8,
                  py: 0.3,
                  borderRadius: 5,
                  border: "1px solid",
                  borderColor: "divider",
                  backgroundColor: "background.paper",
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                96%
              </Box>
              <Typography variant="body2">
                The <b>match score</b> in the corner shows how well your event
                profile answers line up with theirs.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <FavoriteIcon sx={{ color: "#68C371", flexShrink: 0 }} />
              <Typography variant="body2">
                Tap a guest to see more, then hit the <b>heart</b> to like them.
                Anyone you like turns green.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onNext} variant="contained" fullWidth>
            Next
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  if (step === "filter" && rect) {
    const pad = 6;

    return (
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: (t) => t.zIndex.modal + 1,
        }}
      >
        <Box
          onClick={onFinish}
          sx={{ position: "fixed", inset: 0, cursor: "pointer" }}
        />

        <Box
          sx={{
            position: "fixed",
            top: rect.top - pad,
            left: rect.left - pad,
            width: rect.width + pad * 2,
            height: rect.height + pad * 2,
            borderRadius: "50%",
            boxShadow: "0 0 0 9999px rgba(0,0,0,0.6)",
            pointerEvents: "none",
          }}
        />

        <Paper
          elevation={8}
          sx={{
            position: "fixed",
            top: rect.bottom + 14,
            right: 12,
            maxWidth: 260,
            p: 2,
            borderRadius: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <TuneIcon color="primary" />
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Filter the list
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Tap here to narrow the guest list down to the things that matter most
            to you — interests, values, lifestyle and more.
          </Typography>
          <Button onClick={onFinish} variant="contained" fullWidth>
            Got it
          </Button>
        </Paper>
      </Box>
    );
  }

  return null;
};

export default GuestListTutorial;
